export default __webpack_public_path__ + "static/media/selected-document.24389977.png";